import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimeoffCategoryStateType, TimeoffCategoryType } from "../../../types";
import { createTimeOffRequest, updateTimeoffRequest } from "../timeoff/api";
import { createTimeoffCategory, updateTimeoffCategory } from "./api";

const initialState: TimeoffCategoryStateType = {
    isAddingCategory: false,

    isCategoryEditMode: false,

    isPolicyEditMode: false,
};

const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
        setCategoryEditMode: (state, action: PayloadAction<boolean>) => {
            state.isCategoryEditMode = action.payload;
        },

        setSelectedCategoryToEdit: (state, action: PayloadAction<TimeoffCategoryType | undefined>) => {
            state.selectedCategoryToEdit = action.payload;
        },

        clearSelectedCategoryToEdit: (state) => {
            state.selectedCategoryToEdit = undefined;
        },

        setPolicyEditMode: (state, action: PayloadAction<boolean>) => {
            state.isPolicyEditMode = action.payload;
        },

        setSelectedPolicyToEdit: (state, action: PayloadAction<TimeoffCategoryType | undefined>) => {
            state.selectedPolicyToEdit = action.payload;
        },

        clearSelectedPolicyToEdit: (state) => {
            state.selectedPolicyToEdit = undefined;
        },
    },
    extraReducers: {
        [createTimeoffCategory.pending.type]: (state) => {
            state.isAddingCategory = true;
        },

        [createTimeoffCategory.fulfilled.type]: (state) => {
            state.isAddingCategory = false;
        },

        [createTimeoffCategory.rejected.type]: (state) => {
            state.isAddingCategory = false;
        },

        [updateTimeoffCategory.pending.type]: (state) => {
            state.isAddingCategory = true;
        },

        [updateTimeoffCategory.fulfilled.type]: (state) => {
            state.isAddingCategory = false;
        },

        [updateTimeoffCategory.rejected.type]: (state) => {
            state.isAddingCategory = false;
        },
    },
});

export const {
    setCategoryEditMode,
    setSelectedCategoryToEdit,
    clearSelectedCategoryToEdit,
    setPolicyEditMode,
    clearSelectedPolicyToEdit,
    setSelectedPolicyToEdit,
} = categorySlice.actions;

export default categorySlice.reducer;
